import {
  useFloating,
  useInteractions,
  useRole,
  useDismiss,
  FloatingPortal,
  FloatingOverlay,
  FloatingFocusManager,
} from "@floating-ui/react";
import { clsx } from "clsx";
import { YoutubeModalProps } from "./YoutubeModalProps";
import classes from "./YoutubeModal.module.scss";
import { Times } from "@/components/ui/Icon/Times";

export function YoutubeModal(props: YoutubeModalProps) {
  const { isOpen, onClose, videoId, className } = props;

  const youtubeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  const { refs, context } = useFloating({
    open: isOpen,
    onOpenChange: (open) => {
      if (!open) onClose();
    },
  });

  const { getFloatingProps } = useInteractions([
    useRole(context, { role: "dialog" }),
    useDismiss(context),
  ]);

  return (
    <FloatingPortal>
      {isOpen && (
        <FloatingOverlay lockScroll className={classes.overlay}>
          <FloatingFocusManager context={context}>
            <div
              {...getFloatingProps({
                ref: refs.setFloating,
                className: clsx(classes.modal, className),
              })}
            >
              <button
                className={classes.closeButton}
                type="button"
                onClick={onClose}
                aria-label="Close"
              >
                <Times color="#fff" size={30} strokeWidth={2} />
              </button>

              <iframe
                data-testid="video-player"
                width="560"
                height="315"
                src={youtubeUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </FloatingFocusManager>
        </FloatingOverlay>
      )}
    </FloatingPortal>
  );
}
